import { orderByHilbertCurve } from "utils/math/orderByHilbertCurve";
import { bboxCenter } from "utils/math/bboxCenter";
import type { OrderBboxItemsByHilbertCurve } from "./types";

export const orderBboxItemsByHilbertCurve: OrderBboxItemsByHilbertCurve = ({
  elements,
}) => {
  const elementsWithPosition = elements.map((element) => ({
    element,
    position: bboxCenter({ bbox: element.bbox }),
  }));

  const ordered = orderByHilbertCurve({ elements: elementsWithPosition });

  return ordered.map((entry) => entry.element);
};
